/**
 * Pobiera listę produktów (listings) dla danego dostawcy.
 * @param {Object} sdk - Instancja Sharetribe SDK z Twojego hooka useSdk
 * @param {Object} params - Parametry filtrowania, np. { providerId: '...' }
 * @returns {Promise<Array>} Lista produktów
 */
export const fetchProducts = (sdk, params) => {
  const { page = 1, perPage = 5, ...rest } = params;
  return sdk.newSdk.listings
    .query({
      ...rest,
      page,
      per_page: perPage,
      include: ['images', 'catalogItem'],
    })
    .then(response => response);
};

export const fetchPiecesForProduct = (sdk, listingId, params = {}) => {
  if (!listingId) return Promise.resolve({ data: [], meta: {} });

  const queryPayload = {
    listingId,
    ...params,
  };

  return sdk.newSdk.pieces
    .query(queryPayload)
    .then(response => {
      const rawData = response?.data || response;
      const data = Array.isArray(rawData?.data) ? rawData.data : (Array.isArray(rawData) ? rawData : []);
      const meta = rawData?.meta || {};

      return { data, meta };
    })
    .catch(error => {
      console.error(`Błąd podczas pobierania sztuk dla listingu ${listingId}:`, error);
      throw error;
    });
};